import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";


@Component({
    selector: 'app-trade-press',
    templateUrl: './trade-press.component.html'
})

export class TradePressComponent implements OnInit {

    public slug;
    public page = {
        title: '',
        slug: '',
        cover_image: '',
        banner_text: '',
        content: '<h1>404</h1>'
    };
    brochures = [];

    constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient, public _auth: AuthService) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.brochures = [];

            this.getPage(this.slug);
        });

    }

    getPage(slug) {
        this.slug = slug;
        this.http.get(Conf.API_URL + '/bar/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.page = data['results'][0];
                } else {
                    this.page = {
                        title: '',
                        slug: '',
                        cover_image: '',
                        banner_text: '',
                        content: '<h1>404</h1>'
                    }
                }
                if (this.slug == 'brochures') {
                    this.http.get(Conf.API_URL + '/brochures/').subscribe(
                        data => {
                            if (data['results'].length) {
                                this.brochures = data['results'];
                            }
                        },
                        error => {
                            console.log(error.error)
                        }
                    );
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/trade-press/trade-press.component.ts